import { API_ROUTES } from "../constants/apiRoutes";
import {
  GenerateLaoQRResponse,
  PaymentChannelsResponse,
} from "../types/payment";
import { axiosClient } from "./axios";

export const getPaymentChannels =
  async (): Promise<PaymentChannelsResponse> => {
    const res = await axiosClient.get(API_ROUTES.PAYMENT_CHANNELS);
    return res.data;
  };

export interface PaymentStatusResponse {
  code: string;
  data?: Data;
}

export interface Data {
  status: string;
  transactionId: string;
  amount: number;
  orderId: string;
  updatedAt: string;
  channelId: string;
}

export const postPaymentStatus = async (
  orderId: string
): Promise<PaymentStatusResponse> => {
  const res = await axiosClient.post(API_ROUTES.CHECK_PAYMENT_STATUS, {
    orderId,
  });
  return res.data;
};

export const postGenerateLaoQR = async (
  paymentChannelId: string,
  orderId: string
): Promise<GenerateLaoQRResponse> => {
  const res = await axiosClient.post(API_ROUTES.LAO_QR, {
    paymentChannelId,
    orderId,
  });
  return res.data;
};
